export enum PackageLimitReachedType {
  JOIN_CHANNEL = 'JoinChannel',
  ADD_MEMBERS = 'AddMembers',
  UPLOAD_TO_VOD = 'UploadToVod',
  RECORDING = 'Recording',
  ONLINE_CLASS = 'OnlineClass',
  REMOVE_ADMIN = 'RemoveAdmin',
}
